import React, { useState } from "react";
import { createPortal } from "react-dom";
import { calcPos } from "../constants";

// Header "Export" button. Open state and outside-click refs live in useCandidatesV2.
const ExportDropdown = ({ open, setOpen, wrapRef, portalRef, loading, disabled, onExport }) => {
  const [pos, setPos] = useState(null);

  const toggle = () => {
    if (!open && wrapRef.current) setPos(calcPos(wrapRef.current, 4, 220));
    setOpen((s) => !s);
  };

  return (
    <>
      <div ref={wrapRef}>
        <button className="header-action-btn-v2" disabled={loading || disabled} onClick={toggle}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          {loading ? "Exporting…" : "Export"}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" style={{ marginLeft: 2 }}>
            <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      {open && pos && createPortal(
        <div className="export-dropdown-v2" ref={portalRef}
          style={{ position: "fixed", top: pos.top, left: pos.left, zIndex: 9999 }}>
          <button type="button" className="export-dd-item" onClick={() => onExport("csv")}>
            <span>CSV – all matches</span>
            <small>Up to 10,000 rows</small>
          </button>
          <button type="button" className="export-dd-item" onClick={() => onExport("xlsx")}>
            <span>Excel (XLSX) – all matches</span>
            <small>Up to 10,000 rows</small>
          </button>
        </div>,
        document.body
      )}
    </>
  );
};

export default ExportDropdown;
